import * as React from 'react';
import { IMtaActions, IMtaFormNames, IMtaState, PageForm } from '../../../../../../../../services/mta/models';
import { Field, formValueSelector, InjectedFormProps, reduxForm } from 'redux-form';
import { IBrandingActions, II18nMessages } from '../../../../../../../../services/branding/models';
import { flow, get, set } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { mtaActions } from '../../../../../../../../services/mta/actions';
import { actions as brandingActions } from '../../../../../../../../services/branding/reducer';
import { Button, Col, ControlLabel, Form, FormGroup, Grid } from 'react-bootstrap';
import { FaSpinner } from 'react-icons/fa';
import { showDestinations, showRegions } from '../../../../../../../../data/api/api';
import FieldFormControl from '../../../../../../../../components/FieldFormControl';
import AlternativeDatePicker from '../../../../../../../../components/AlternativeDatePicker';
import {
  annualLimit,
  isRequired,
  isValidDate,
  minTripDuration,
  singleLimit,
  singleMaxTripDuration,
  validateIsFutureDate
} from '../../../../../../../../util/validators';
import { dateFromApi, dateToApi } from '../../../../../../../../data/api/transformers/application';
import Loading from '../../../../../../../../components/Loading';
import { MTACardHeader } from '../Components/MTACardHeader';
import { MTAButtons } from '../../../MTAButtons';
import { Link } from 'react-router-dom';
import { addDays, parse } from 'date-fns';

interface IMTAChangeTripDateFormProps extends InjectedFormProps<any> {
  mta: IMtaState;
  i18n: II18nMessages;
  formValues: any;
  selectedPolicy: any;
  dispatch: any;
  change: any;
  actions: {
    branding: IBrandingActions;
    mta: IMtaActions
  };
}

export class MTAChangeTripDateForm extends React.Component<IMTAChangeTripDateFormProps, any> {
  private startDatePicker: any;
  private endDatePicker: any;

  constructor(props) {
    super(props);
    const { dispatch, change } = props;
    dispatch(change('page', PageForm.MTA_CHANGE_TRIP_DATES));
    window.scrollTo(0, 0);
    this.startDatePicker = React.createRef();
    this.endDatePicker = React.createRef();
  }

  public handleSubmit = () => {
    const { actions, formValues } = this.props;
    set(formValues, 'page', PageForm.MTA_CHANGE_TRIP_DATES);
    this.setDates(true);

    Promise.all([
      actions.mta.calculateMtaPremiums(),
    ]).then(() => {
      actions.mta.addEndorsements();
      actions.mta.handleMTASubmit();
    });
  }

  private onClickEvent(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  private setDates = (toApi: boolean = false) => {
    const { formValues, dispatch, change } = this.props;
    const startDate = get(formValues, 'attributes.metadata.start_date', null);
    const endDate = get(formValues, 'attributes.metadata.end_date', null);
    let convertedStartDate: string;
    let convertedEndDate: string;

    if (toApi) {
      convertedStartDate = dateToApi(startDate)
      convertedEndDate = dateToApi(endDate)
    } else {
      convertedStartDate = dateFromApi(startDate)
      convertedEndDate = dateFromApi(endDate)
    }

    if (startDate) {
      dispatch(change('data.attributes.metadata.start_date', convertedStartDate))
    }

    if (endDate) {
      dispatch(change('data.attributes.metadata.end_date', convertedEndDate))
    }
  }

  public componentWillMount() {
    this.setDates();
  }

  private renderDatePicker = () => {
    const { mta, formValues } = this.props;
    const tripType = get(mta, 'selectedPolicy.metadata.scheme_type', '');
    const startDate = get(formValues, 'attributes.metadata.start_date', null);
    return (
      <>
        <div style={{ margin: '20px 0 20px 0' }}>
          <FormGroup controlId="start-date" className="start-date">
            <Col componentClass={ControlLabel} xs={2} onClick={this.onClickEvent}>
              {showDestinations(tripType) ? 'Departure date ' : 'Start Date '}
            </Col>
            <Col xs={10} className="date-picker" onClick={this.onClickEvent}>
              <div className="mta-alternative-date-picker">
                <div className="field start-date-input">
                  <Field
                    name="data.attributes.metadata.start_date"
                    type="masked-date"
                    inputmode="numeric"
                    placeholder="dd/mm/yyyy"
                    component={FieldFormControl}
                  />
                </div>
                <div className="icon" ref={this.startDatePicker}>
                  <Field
                    name="data.attributes.metadata.start_date"
                    minDate={addDays(new Date(), 1)}
                    maxDate={showRegions(tripType) ?
                      addDays(new Date(), 180) :
                      addDays(new Date(), 365)
                    }
                    component={AlternativeDatePicker}
                    validate={showRegions(tripType) ? [
                      isRequired,
                      validateIsFutureDate,
                      isValidDate,
                      annualLimit,
                    ] : [
                      isRequired,
                      validateIsFutureDate,
                      isValidDate,
                      singleLimit,
                    ]}
                  />
                </div>
              </div>
            </Col>
          </FormGroup>
        </div>
        {tripType === 'single' && (
          <div style={{ margin: '20px 0 20px 0' }}>
            <FormGroup controlId="end-date" className="end-date">
              <Col componentClass={ControlLabel} xs={2} onClick={this.onClickEvent}>
                Return date
              </Col>
              <Col xs={10} className="date-picker" onClick={this.onClickEvent}>
                <div className="mta-alternative-date-picker">
                  <div className="field end-date-input">
                    <Field
                      name="data.attributes.metadata.end_date"
                      type="masked-date"
                      inputmode="numeric"
                      placeholder="dd/mm/yyyy"
                      component={FieldFormControl}
                    />
                  </div>
                  <div className="icon">
                    <Field
                      name="data.attributes.metadata.end_date"
                      minDate={startDate ? addDays(parse(startDate, 'dd/MM/yyyy', new Date()), 1) : new Date()}
                      maxDate={
                        parse(startDate, 'dd/MM/yyyy', new Date()) < addDays(new Date(), 91) ?
                          addDays(new Date(), 365) : addDays(new Date(), 455)}
                      component={AlternativeDatePicker}
                      validate={[
                        isRequired,
                        validateIsFutureDate,
                        isValidDate,
                        minTripDuration(startDate),
                        singleMaxTripDuration(startDate),
                      ]}
                    />
                  </div>
                </div>
              </Col>
            </FormGroup>
          </div>
        )}
      </>
    )
  }

  render() {
    const { mta, handleSubmit, submitting, submitFailed, valid } = this.props;
    const isLoading = mta.isLoading;
    const submitButton = (
      <Button
        bsStyle="primary"
        type="submit"
        bsSize="small"
        className="medium-width pull-right"
        disabled={submitting || (submitFailed && !valid || !valid || isLoading)}>
        {isLoading && (
          <FaSpinner className="fa-spin"/>
        )}
        APPLY CHANGES
      </Button>
    );

    const goBackButton = (
      <Link to="/account/summary">
        <Button
          bsStyle={'primary'}
          className={'secondary-button'}>
          GO BACK
        </Button>
      </Link>
    )

    return (
      <>
        {isLoading && (
          <Loading/>
        )}
        <>
          {!isLoading && (
            <>
              <Form horizontal={true} onSubmit={handleSubmit(this.handleSubmit)} autoComplete="off">
                <div className="admiral-card" style={{ marginTop: '20px' }}>
                  <MTACardHeader
                    text={'Update your travel dates below.'}
                    subtext={'Please select the duration of your trip using the departure and return calendars provided.'}
                    icon={'calendar3'}
                    border={true}
                  />
                  <div className="body">
                    <Grid fluid={true}>
                      {this.renderDatePicker()}
                    </Grid>
                  </div>
                </div>
                <div style={{ marginTop: '15px' }}/>
                <MTAButtons button1={goBackButton} button2={submitButton}/>
              </Form>
            </>
          )}
        </>
      </>
    )
  }
}

let selector;

export default flow([
  reduxForm({
    form: IMtaFormNames.COVER_DETAILS,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector(IMtaFormNames.COVER_DETAILS);
    return component;
  },
  connect(
    (state: IStore) => {
      const values = selector(
        state,
        'data',
      );
      return {
        mta: state.mta,
        selectedPolicy: state.mta.selectedPolicy,
        i18n: state.branding.i18n,
        formValues: values,
      };
    },
    (dispatch) => ({
      actions: {
        mta: bindActionCreators({ ...mtaActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
      },
    }),
  ),
])(MTAChangeTripDateForm);
